export default __webpack_public_path__ + "static/media/undraw_informed_decision_p2lh.2a7a15f0.svg";